module.exports = __webpack_public_path__ + "static/media/KUYV4654.b3edef6c.JPG";